import { render, staticRenderFns } from "./dialogOrderExpress.vue?vue&type=template&id=48a9e9ca&scoped=true&"
import script from "./dialogOrderExpress.vue?vue&type=script&lang=js&"
export * from "./dialogOrderExpress.vue?vue&type=script&lang=js&"
import style0 from "./dialogOrderExpress.vue?vue&type=style&index=0&id=48a9e9ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9e9ca",
  null
  
)

export default component.exports